import { callApiWithAuthorization } from "../CallApi";
import { getUserDataFromContext } from "../Organization/organization";

export async function getLoggedInUserUsingAccessToken() {
    const request = await callApiWithAuthorization("/api/v0/current-user");
    const response = await request.json();
    return response;
}

export async function getRoleOfUserInProject(projectId, email) {
    const request = await callApiWithAuthorization(`/api/v0/user/${email}/projects/${projectId}/role`);
    const response = await request.json();
    return response;
}

export async function getUserByEmail(email) {
    const request = await callApiWithAuthorization("/api/v0/user/" + email);
    const response = await request.json();
    return response;
}

export async function updateUser(user) {
    const userId = user._id;
    delete user._id;
    const request = await callApiWithAuthorization("/api/v0/user/" + userId, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(user)
    });
    const response = await request.json();
    return response;
}

export async function getAzureUser(context) {
    let user = {}
    if (context.accounts.length === 0) {
        user = await getLoggedInUserUsingAccessToken()
    } else {
        user = context.accounts[0].idTokenClaims
    }
    return user
}